<template>
	<div class="m-details">
		<Header @toggleLang="toggleLang" @toggleNext="toggleNext"></Header>
		<div class="waterfull">

			<div class="main">
				<div class="left">
					<img class="pic" :src="content.image" v-image-preview />
					<div class="swiper-wrap">
						<div class="s-container">
							<swiper :options="swiperOption" ref="mySwiper" :pagination="{clickable:true}">
								<div class="swiper-slide" v-for="(item,index) in image" :key="item"
									@click="content.image=item">
									<div class="item">
										<div class="photo"> <img :src="item" alt="" /></div>
									</div>
								</div>
							</swiper>
							<div class="swiper-pagination"></div>
							<div class="swiper-button-prev"></div>
							<div class="swiper-button-next"></div>
							<!-- <div class="swiper-scrollbar"></div> -->
						</div>
					</div>
				</div>
				<div class="right">
					<div class="title">
						{{lang=='CN' ?content.cn_title:content.en_title}}
					</div>
					<div class="info">
						<span>文物编号</span><em>：</em>
						<div class="txt">{{content.seo1}}</div>
					</div>
					<div class="info">
						<span>年代</span><em>：</em>
						<div class="txt">{{content.seo2}}</div>
					</div>
					<div class="info">
						<span>描述</span><em>：</em>
						<div class="txt">{{content.seo3}}</div>
					</div>
				</div>
			</div>

			<!--文物详情页 GO-->
			<div class="detail" v-if="content.cn_content.length>11">
				<div class="info_tit">
					<div class="tit_left">
						<span>文物详情 </span>
						<el-divider direction="vertical"></el-divider>
						<span>Digital Detail</span>
					</div>

				</div>

				<div class="info_detail" v-html="lang=='CN' ?content.cn_content:content.en_content"></div>

			</div>

			<div class="recommend">

				<div class="info_tit">
					<div class="tit_left">
						<span>相关推荐 </span>
						<el-divider direction="vertical"></el-divider>
						<span>RECOMMEND</span>
					</div>

				</div>

				<div class="list">
					<div class="item" v-for="(item,index) in waterfallList" @click="id=item.id;detail();scrollTop()"
						v-if="item.id!=content.id">
						<div class="pics">
							<img class="pic" :src="item.image" alt="">
						</div>
						<div class="mask css3"></div>
						<div class="tit css3">{{item.seo1}}</div>
						<div class="txt css3">{{item.seo2}}</div>
					</div>
				</div>
				<div class="share">
					<span> {{lang=='CN' ?'分享到':'Share To'}}:</span>
					<img class="pointer" @click="shareToRoom()" src="@/assets/news/zone.png" />
					<img class="pointer" @click="shareToQQ()" src="@/assets/news/qqicon.png" />
					<img class="pointer" @click="shareToMicroblog()" src="@/assets/news/weibo.png" />
				</div>
			</div>

		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		archives_list,
		archives_detail
	} from '@/api/api.js'
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper"
	import 'swiper/css/swiper.css'
	export default {
		name: 'digital_cultural_detail',
		components: {
			Header,
			Footer,
			swiper,
			swiperSlide
		},
		data() {
			return {
				lang: localStorage.getItem('lang') || 'CN',
				id: '',
				content: {},
				image: [],
				waterfallList: [],
				per_page: 8,
				keyword: '',
				page: 1,
				http: this.prod,
				swiperOption: {
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 5,
					slidesPerGroup: 5,
					// 显示分页
					// pagination: {
					//   el: ".swiper-pagination",
					//   clickable: true //允许分页点击跳转
					// },
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					}
				},
			}
		},
		created() {
			// 触发入口
			this.id = this.$route.query.id
		},
		mounted() {
			this.detail()
			this.getCateglory()
		},
		methods: {
			scrollTop() {
				$("html, body").animate({
					scrollTop: $("#app").offset().top
				}, {
					duration: 500,
					easing: "swing"
				});
				return false;
			},
			getCateglory() {
				let data = {
					channel_id: 54,
					per_page: this.per_page,
					page: this.page,
					keyword: this.keyword,
				}
				archives_list(data).then(res => {
					if (res.code == 1) {
						this.waterfallList = res.data.data
						// this.imgList=res.data.data
					}
				}).catch(err => {});
			},
			detail() {
				let data = {
					id: this.id
				}
				archives_detail(data).then(res => {
					if (res.code == 1) {
						this.content = res.data
						this.image = this.content.images_arr
						// this.image=this.content.images.split(',');
						// this.image=this.image.map(item=>{
						// 	if(item.indexOf('http')){
						// 		return item=this.http+item
						// 	}else{
						// 		return item
						// 	}
						// })
					}
				}).catch(err => {});
			},
			//分享到QQ好友(PC端可用)
			shareToQQ() {
				//此处分享链接内无法携带图片
				const share = {
					title: this.content.cn_title,
					desc: this.content.cn_digest,
					share_url: window.location.href,
				};
				window.open(
					"https://connect.qq.com/widget/shareqq/index.html?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" +
					share.title +
					"&desc=" +
					share.desc
				);
			},
			//分享到QQ空间(可用)
			shareToRoom() {
				//自定义内容
				const share = {
					title: this.content.cn_title,
					desc: this.content.cn_digest,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				let image_urls = share.image_url.map(function(image) {
					return encodeURIComponent(image);
				});
				//跳转地址
				window.open(
					"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" + share.title +
					"&pics=" + image_urls.join("|") +
					"&summary=" + share.desc
				);
			},
			//分享到微博(可用)
			shareToMicroblog() {
				//自定义内容
				const share = {
					title: this.content.cn_title,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				//跳转地址
				// location.replace(
				window.open(
					"https://service.weibo.com/share/share.php?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" + share.title +
					"&pic=" + share.image_url +
					"&searchPic=true"
				);
			},
			//分享到微信(不可用)
			shareToWeChat() {
				//自定义内容
				// return
				const share = {
					title: this.content.cn_title,
					image_url: [this.content.image],
					share_url: window.location.href
				};
				//跳转地址
				window.open(
					"http://zixuephp.net/inc/qrcode_img.php?url=" +
					encodeURIComponent(share.share_url)
				);
			},
			toggleLang(str) {},
			toggleNext(index) {},

		}
	}
</script>

<style lang="scss" scoped>
	.m-details {

		background: #d9b96c url(../assets/dig-bg.png) 0 0 repeat;

	}

	.waterfull {
		max-width: 1400px;
		margin: 20px auto;
		padding: 30px;
		padding-top: 0;
		overflow: hidden;

		/**通用标题 */
		.info_tit {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;
			cursor: pointer;
		}

		.info_tit .active {
			border: 2px solid #006170;
			box-shadow: 5px 7px 10px #cddadc;
			color: #000;
		}

		.info_tit .tit_left span:first-child {
			font-size: 30px;
			color: #000;
			font-weight: bold;
		}

		.info_tit .tit_left span:last-child {
			font-size: 14px;
			color: #999;
		}

		.main {
			display: flex;
			flex-wrap: nowrap;
			background-color: #FFFFFF;
			padding: 30px;
			padding-top: 30px;

			.left {
				width: 900px;
				overflow: hidden;
				text-align: center;
				.pic {
					width: 100%;
					height: 600px;
					object-fit: contain;
					cursor: pointer;
				}

				.swiper-wrap {
					height: 200px;
					position: relative;
					overflow: hidden;
					margin: 15px 0 0 0;

					.s-container {

						.swiper-button-prev,
						.swiper-button-next {
							width: 35px;
							height: 35px;
							left: initial;
							position: absolute;
							color: #d6d7dc;
							// top: 22px;
						}

						.swiper-button-next {
							right: 5px;
						}

						.swiper-container {
							width: calc(100% + 23.8px) !important;
						}

						.swiper-slide {
							width: 100%;
							height: 100%;

							.item {
								width: 150px;
								height: 180px;
								float: left;
								margin-right: 20px;
								overflow: hidden;
								cursor: pointer;

								.photo {
									img {
										width: 150px;
										height: 180px;
									}
								}
							}

							&:nth-child() {}
						}
					}
				}
			}

			.right {
				width: 500px;
				margin-left: 20px;

				.title {
					text-align: left;
					font-size: 24px;

				}


				.info {
					overflow: hidden;
					margin-top: 30px;
					font-size: 18px;
					color: #000000;

					em {
						display: inline-block;
						float: left;
						width: 30px;
						line-height: 30px;
						color: #666666;
					}

					.txt {
						display: inline-block;
						float: left;
						width: calc(100% - 110px);
						line-height: 30px;
					}
				}

				span {
					font-size: 16px;
					width: 80px;
					line-height: 30px;
					display: inline-block;
					text-align: justify;
					text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
					text-align-last: justify;
					color: #666666;
					float: left;
				}
			}
		}

		.detail {
			margin-top: 20px;
			padding: 20px 30px 30px;
			background: #FFFFFF url(../assets/detail-bg.png) 800px -150px repeat-y;
		}

		.recommend {
			margin-top: 20px;
			background-color: #FFFFFF;
			padding: 20px 30px 30px;

			.title {
				font-size: 24px;

				padding: 20px 0;

				span {
					color: #999999;
					padding-left: 20px;
					border-left: 1px solid #d6d7dc;
					font-size: 16px;
					margin-left: 10px;
				}
			}

			.list {
				overflow: hidden;
				height: 240px;
				overflow: hidden;

				.item {
					width: 174px;
					height: 220px;
					position: relative;
					float: left;
					margin: 0 0 20px 20px;
					overflow: hidden;

					.mask {
						background: rgba(0, 0, 0, 0.5);
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						cursor: pointer;
						display: none;
					}

					.tit,
					.txt {
						position: absolute;
						left: 0;
						width: 100%;
						text-align: center;
						height: 40px;
						line-height: 40px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						color: #ffffff;
					}

					.tit {
						top: -100%;
					}

					.txt {
						bottom: -100%;
					}

					&:hover .mask {
						display: block;
					}

					&:hover .tit {
						top: 50%;
						margin-top: -40px;
					}

					&:hover .txt {
						bottom: 50%;
						margin-bottom: -40px
					}
				}

				.item:nth-child(7n+1) {
					margin-left: 0px;
				}


				.pic {
					width: 174px;
					height: 220px;
					object-fit: cover;
					cursor: pointer;
				}
			}
		}

		.share {
			margin-top: 60px;

			img {
				width: 30px;
				height: 30px;
				margin-right: 20px;
			}

			img:hover {
				background: none;
			}

			span {
				margin-right: 20px;
			}
		}
		/deep/ .info_detail img{ max-width: 100%!important;}
	}
</style>
<style type="text/css">
	.vue-directive-image-previewer {
		z-index: 999 !important;
	}
</style>
